import React, { useEffect, useState, useMemo } from "react";
import Header from "../components/Header";
import Footer from "../components/Footer";
import { Link, useNavigate, useParams } from "react-router-dom";
import { IoIosArrowForward } from "react-icons/io";
import "react-multi-carousel/lib/styles.css";
import Rating from "../components/Rating";
import { FaHeart } from "react-icons/fa6";
import { FaFacebookF, FaInstagram, FaTiktok } from "react-icons/fa";
import ScrollToTop from "../components/ScrollToTop";
import { Pagination } from "swiper/modules";
import "swiper/css";
import "swiper/css/pagination";
import { Swiper, SwiperSlide } from "swiper/react";
import { useDispatch, useSelector } from "react-redux";
import {
  product_details,
  get_brand_by_name,
  clearBrandDetails,
} from "../store/reducers/homeReducer";
import toast from "react-hot-toast";
import {
  add_to_card,
  messageClear,
  add_to_wishlist,
} from "../store/reducers/cardReducer";
import useGuestId from "../hooks/useGuestId";
import { FaRuler, FaTimes, FaDownload } from "react-icons/fa";
import ModalCarrito from "../components/ModalCarrito";


import "react-inner-image-zoom/lib/styles.min.css";
import InnerImageZoom from "react-inner-image-zoom";

const TEXT_SIZE_ORDER = {
  'XXS':1,'XS':2,'S':3,'M':4,'L':5,'XL':6,'XXL':7,'XXXL':8,'3XL':8,'4XL':9
};

const sortSizes = (sizes = []) => {
  return [...sizes].sort((a, b) => {
    // 1. Si tienen rowindex definido y distinto de 0, usarlo
    const riA = a.rowindex ?? 0;
    const riB = b.rowindex ?? 0;
    if (riA !== 0 || riB !== 0) return riA - riB;

    // 2. Intentar parsear como número
    const numA = parseFloat(a.size);
    const numB = parseFloat(b.size);
    if (!isNaN(numA) && !isNaN(numB)) return numA - numB;

    // 3. Fallback mapa texto
    const tA = TEXT_SIZE_ORDER[(a.size || '').toUpperCase()] ?? 999;
    const tB = TEXT_SIZE_ORDER[(b.size || '').toUpperCase()] ?? 999;
    if (tA !== tB) return tA - tB;

    // 4. Alfabético
    return (a.size || '').localeCompare(b.size || '');
  });
};

const Details = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { currentCompany } = useSelector((state) => state.init);
  const { userInfo } = useSelector((state) => state.auth);
  const guestId = useGuestId();

  const originUrl = window.location.origin;
  const bgStyle = {
    backgroundImage: `url(${originUrl}/images/banner/shop.png)`,
    backgroundPosition: "center",
    backgroundSize: "cover",
  };

  const { slug } = useParams();

  const { product, relatedProducts, moreProducts, brandDetails, brandLoading } =
    useSelector((state) => state.home);
  const { errorMessage, successMessage } = useSelector((state) => state.card);
  const [selectedImage, setSelectedImage] = useState("");

  const [quantity, setQuantity] = useState(1);
  const [selectedSize, setSelectedSize] = useState(null);
  const [selectedVariant, setSelectedVariant] = useState(null);
  const [sizeGuideModal, setSizeGuideModal] = useState(false);
  const [cartModal, setCartModal] = useState(false);
  const [cartModalPrice, setCartModalPrice] = useState(0);
  

  // Función corregida para obtener imagen principal
  const getMainImage = (product) => {
    if (!product || typeof product !== "object") {
      return "https://via.placeholder.com/280x280?text=Imagen+No+Disponible";
    }

    // Verificar si hay variantes
    if (
      !product.variants ||
      !Array.isArray(product.variants) ||
      product.variants.length === 0
    ) {
      return product.images &&
        Array.isArray(product.images) &&
        product.images.length > 0
        ? product.images[0]
        : "https://via.placeholder.com/280x280?text=Imagen+No+Disponible";
    }

    const primeraVariante = product.variants[0];

    if (
      primeraVariante.colorImages &&
      Array.isArray(primeraVariante.colorImages) &&
      primeraVariante.colorImages.length > 0
    ) {
      return primeraVariante.colorImages[0];
    }

    // Verificar que sizes exista y sea array antes de usar find
    if (primeraVariante.sizes && Array.isArray(primeraVariante.sizes)) {
      const tallaConStock = primeraVariante.sizes.find(
        (size) => size && size.stock > 0
      );
      if (tallaConStock && tallaConStock.image) {
        return tallaConStock.image;
      }
    }

    // Fallback a images del producto
    return product.images &&
      Array.isArray(product.images) &&
      product.images.length > 0
      ? product.images[0]
      : "https://via.placeholder.com/280x280?text=Imagen+No+Disponible";
  };

  // Función corregida para obtener precio principal
  /*
  const getMainPrice = (product) => {
    if (!product || typeof product !== "object") {
      return 0;
    }

    // Verificar si hay variantes
    if (
      !product.variants ||
      !Array.isArray(product.variants) ||
      product.variants.length === 0
    ) {
      return product.price > 0 ? product.price : 0;
    }

    const primeraVariante = product.variants[0];

    // Verificar que sizes exista y sea array antes de usar find
    if (primeraVariante.sizes && Array.isArray(primeraVariante.sizes)) {
      const tallaConStock = primeraVariante.sizes.find(
        (size) => size && size.stock > 0
      );
      if (tallaConStock && tallaConStock.price) {
        return tallaConStock.price;
      }
    }

    return product.price > 0 ? product.price : 0;
  };

*/

  // Precio calculado CORREGIDO
  const calculatedPrice = useMemo(() => {
    if (!product) return 0;

    // Para productos con variantes y talla seleccionada
    if (product.hasVariants && selectedSize && selectedVariant) {
      const sizeObj = selectedVariant.sizes?.find(
        (s) => s && s.size === selectedSize
      );
      return sizeObj?.price || product.price || 0;
    }

    // Para productos sin variantes
    return product.price || 0;
  }, [product, selectedSize, selectedVariant]);

  // Descuento calculado CORREGIDO
  const calculatedDiscount = useMemo(() => {
    if (!product) return 0;

    // Para productos con variantes y talla seleccionada
    if (product.hasVariants && selectedSize && selectedVariant) {
      const sizeObj = selectedVariant.sizes?.find(
        (s) => s && s.size === selectedSize
      );
      return sizeObj?.discount > 0 ? sizeObj.discount : 0;
    }

    // Para productos sin variantes
    return product.discount > 0 ? product.discount : 0;
  }, [product, selectedSize, selectedVariant]);

  // Stock disponible CORREGIDO
  const currentStock = useMemo(() => {
    if (!product) return 0;

    if (product.hasVariants && selectedSize && selectedVariant) {
      const sizeObj = selectedVariant.sizes?.find(
        (s) => s && s.size === selectedSize
      );
      return sizeObj ? sizeObj.stock : 0;
    } else {
      return product.stock || 0;
    }
  }, [product, selectedSize, selectedVariant]);

  // Verificar si hay descuento activo
  const hasActiveDiscount = useMemo(() => {
    return calculatedDiscount > 0 && calculatedDiscount < calculatedPrice;
  }, [calculatedDiscount, calculatedPrice]);

  // Porcentaje de descuento
  const discountPercentage = useMemo(() => {
    if (!hasActiveDiscount) return 0;
    return Math.round(
      ((calculatedPrice - calculatedDiscount) / calculatedPrice) * 100
    );
  }, [hasActiveDiscount, calculatedPrice, calculatedDiscount]);

  useEffect(() => {
    dispatch(product_details(slug));
  }, [slug, dispatch]);

  useEffect(() => {
    if (successMessage) {
      if (successMessage.toLowerCase().includes('carrito') || successMessage.toLowerCase().includes('card')) {
        setCartModalPrice(hasActiveDiscount ? calculatedDiscount : calculatedPrice);
        setCartModal(true);
      } else {
        toast.success(successMessage);
      }
      dispatch(messageClear());
    }
    if (errorMessage) {
      toast.error(errorMessage);
      dispatch(messageClear());
    }
  }, [successMessage, errorMessage, dispatch, hasActiveDiscount, calculatedDiscount, calculatedPrice]);

  // Efecto mejorado para manejo de imágenes
  useEffect(() => {
    if (!product) return;

    // 1. Productos con variantes
    if (product.hasVariants && selectedVariant) {
      // Priorizar imágenes de la variante seleccionada si existen
      const variantImages = selectedVariant.colorImages || [];
      if (variantImages.length > 0) {
        setSelectedImage(variantImages[0]);
        return;
      }
    }

    // 2. Productos sin variantes o variantes sin imágenes
    if (product.images?.length > 0) {
      setSelectedImage(product.images[0]);
    } else {
      // Imagen por defecto si no hay imágenes
      setSelectedImage("/images/default-product.png");
    }
  }, [product, selectedVariant]);

  // Inicializar variante por defecto si existe
  useEffect(() => {
    if (!product?.hasVariants || !product.variants?.length) {
      setSelectedVariant(null);
      setSelectedSize(null);
      return;
    }

    // Seleccionar la primera variante
    const firstVariant = product.variants[0];
    setSelectedVariant(firstVariant);
    const sortedSizes = sortSizes(firstVariant.sizes || []);
    const firstAvailableSize = sortedSizes.find(size => size && size.stock > 0);
    const defaultSize = firstAvailableSize?.size || sortedSizes[0]?.size || null;
    setSelectedSize(defaultSize);
  }, [product]);

  // eslint-disable-next-line no-unused-vars
  const responsive = {
    superLargeDesktop: {
      breakpoint: { max: 4000, min: 3000 },
      items: 4,
      partialVisibilityGutter: 40,
    },
    desktop: {
      breakpoint: { max: 3000, min: 1024 },
      items: 4,
      partialVisibilityGutter: 40,
    },
    tablet: {
      breakpoint: { max: 1024, min: 464 },
      items: 4,
      partialVisibilityGutter: 30,
    },
    mdtablet: {
      breakpoint: { max: 991, min: 464 },
      items: 4,
      partialVisibilityGutter: 20,
    },
    mobile: {
      breakpoint: { max: 464, min: 0 },
      items: 1,
      partialVisibilityGutter: 30,
    },
    smmobile: {
      breakpoint: { max: 640, min: 0 },
      items: 1,
      partialVisibilityGutter: 10,
    },
    xsmobile: {
      breakpoint: { max: 440, min: 0 },
      items: 1,
      partialVisibilityGutter: 0,
    },
  };

  const inc = () => {
    if (quantity < currentStock) {
      setQuantity(quantity + 1);
    } else {
      toast.error("Stock Agotado");
    }
  };

  const dec = () => {
    if (quantity > 1) {
      setQuantity(quantity - 1);
    }
  };

  const add_card = () => {
    if (product.hasVariants && !selectedSize) {
      toast.error("Por favor selecciona una talla");
      return;
    }
    const payload = {
      quantity,
      productId: product._id,
      variant: null,
    };
    if (product.hasVariants) {
      if (!selectedVariant || !selectedVariant.sizes) {
        toast.error(
          "Hubo un problema al seleccionar la variante del producto."
        );
        return;
      }
      const sizeObj = selectedVariant.sizes.find(
        (s) => s.size === selectedSize
      );
      if (!sizeObj) {
        toast.error(
          "La talla seleccionada no está disponible para esta variante."
        );
        return;
      }
      // Crear el objeto variantString que se almacenará en tu modelo
      const variantString = JSON.stringify({
        color: selectedVariant.color,
        colorCode: selectedVariant.colorCode,
        size: sizeObj.size,
        sizeId: sizeObj._id,
        price: sizeObj.price,
        discount: sizeObj.discount,
        sku: sizeObj.sku,
      });

      payload.variant = variantString;
    }

    if (userInfo) {
      payload.userId = userInfo.id;
    } else if (guestId) {
      payload.userId = guestId;
    }
    dispatch(add_to_card(payload));
  };

  const add_wishlist = () => {
    if (!product || !product._id) {
      console.error("Producto inválido");
      return;
    }
    const wishlistItem = {
      productId: product._id,
      name: product.name || "",
      price: product.price || 0,
      image: product.images?.[0] || "",
      discount: product.discount || 0,
      rating: product.rating || 0,
      slug: product.slug || "",
    };

    if (userInfo) {
      dispatch(add_to_wishlist({ userId: userInfo.id, ...wishlistItem }));
    } else if (guestId) {
      dispatch(add_to_wishlist({ userId: guestId, ...wishlistItem }));
    } else {
      navigate("/login");
    }
  };

  // Obtener las imágenes a mostrar en el carrusel
  const getImagesToDisplay = () => {
    if (!product) return [];

    // Para productos con variantes, usa las imágenes de la variante si existen
    if (product.hasVariants && selectedVariant) {
      const variantImages = selectedVariant.colorImages || [];
      if (variantImages.length > 0) return variantImages;
    }

    // Para productos sin variantes o sin imágenes específicas de variante
    return product.images || [];
  };

  // Función para abrir el modal de guía de tallas
  const openSizeGuide = () => {
    if (product && product.brand) {
      dispatch(get_brand_by_name(product.brand));
      setSizeGuideModal(true);
    } else {
      toast.error("Este producto no tiene información de marca disponible");
    }
  };

  // Función para cerrar el modal
  const closeSizeGuide = () => {
    setSizeGuideModal(false);
    dispatch(clearBrandDetails());
  };

  // Función para obtener información de precios (tanto para productos con/sin variantes)
  const getProductPriceInfo = (product) => {
    if (!product) {
      return {
        hasDiscount: false,
        displayPrice: 0,
        originalPrice: 0,
        discountPercent: 0,
      };
    }

    // PRODUCTOS CON VARIANTES
    if (
      product.hasVariants &&
      product.variants &&
      product.variants.length > 0
    ) {
      const firstVariant = product.variants[0];

      // Si el backend ya proporcionó la información de descuento de variantes
      if (product.variantDiscountInfo) {
        return {
          hasDiscount: product.variantDiscountInfo.hasDiscount,
          displayPrice: product.variantDiscountInfo.displayPrice,
          originalPrice: product.variantDiscountInfo.originalPrice,
          discountPercent: product.variantDiscountInfo.discountPercentage,
        };
      }

      // Si no, calcular manualmente
      if (firstVariant.sizes && firstVariant.sizes.length > 0) {
        const firstSize = firstVariant.sizes[0];
        const hasDiscount =
          firstSize.discount > 0 && firstSize.discount < firstSize.price;
        const displayPrice = hasDiscount ? firstSize.discount : firstSize.price;
        const originalPrice = firstSize.price;
        const discountPercent = hasDiscount
          ? Math.round(
              ((firstSize.price - firstSize.discount) / firstSize.price) * 100
            )
          : 0;

        return { hasDiscount, displayPrice, originalPrice, discountPercent };
      }
    }

    // PRODUCTOS SIN VARIANTES
    // Si el backend ya proporcionó la información
    if (product.hasActiveDiscount !== undefined) {
      return {
        hasDiscount: product.hasActiveDiscount,
        displayPrice: product.hasActiveDiscount
          ? product.discount
          : product.price,
        originalPrice: product.price,
        discountPercent: product.discountPercentage || 0,
      };
    }

    // Si no, calcular manualmente
    const hasDiscount =
      product.discount > 0 && product.discount < product.price;
    const displayPrice = hasDiscount ? product.discount : product.price;
    const originalPrice = product.price;
    const discountPercent = hasDiscount
      ? Math.round(((product.price - product.discount) / product.price) * 100)
      : 0;

    return { hasDiscount, displayPrice, originalPrice, discountPercent };
  };

  const canLoopRelated = relatedProducts.length > 4; // Más que slidesPerView
  const canLoopMore = moreProducts.length > 4; // Más que slidesPerView

  // Imagen principal optimizada para display
  const smallImage = selectedImage.includes('/upload/')
    ? selectedImage.replace('/upload/', '/upload/w_800,q_auto,f_auto/')
    : selectedImage;

  // Imagen zoom: original sin transformaciones para máxima nitidez
  const largeImage = selectedImage.includes('/upload/')
    ? selectedImage.replace('/upload/', '/upload/q_100,f_auto/')
    : selectedImage;

  return (
    <div>
      <ModalCarrito
        isOpen={cartModal}
        product={product}
        quantity={quantity}
        price={cartModalPrice}
        relatedProducts={relatedProducts}
        onClose={() => setCartModal(false)}
      />
      <Header />
      <ScrollToTop />
      {/* ... (resto del componente se mantiene igual) ... */}
      {currentCompany?.verimageDetails && (
        <section
          className="h-[220px] mt-6 bg-cover bg-no-repeat relative bg-left"
          style={bgStyle}
        >
          <div className="absolute left-0 top-0 w-full h-full bg-[#2422228a]">
            <div className="w-[85%] md:w-[80%] sm:w-[90%] lg:w-[90%] h-full mx-auto">
              <div className="flex flex-col justify-center gap-1 items-center h-full w-full text-white">
                <h2 className="text-3xl font-bold">Detalles del producto </h2>
                <div className="flex justify-center items-center gap-2 text-2xl w-full">
                  <Link to="/">Inicio</Link>
                  <span className="pt-1">
                    <IoIosArrowForward />
                  </span>
                  <span>Detalles del producto </span>
                </div>
              </div>
            </div>
          </div>
        </section>
      )}
      <section>
        <div className="bg-slate-100 py-1 mb-1">
          <div className="w-[85%] md:w-[80%] sm:w-[90%] lg:w-[90%] h-full mx-auto">
            <div className="flex justify-start items-center text-xs font-medium tracking-[.075rem] leading-5 text-slate-600 w-full">
              <Link to="/">Inicio</Link>
              <span className="pt-0">
                <IoIosArrowForward />
              </span>
              <Link to="/">{product.category}</Link>
              <span className="pt-0">
                <IoIosArrowForward />
              </span>
              <span>{product.typearticle} </span>
            </div>
          </div>
        </div>
      </section>

      <section>
        <div className="w-[85%] md:w-[80%] sm:w-[90%] lg:w-[90%] h-full mx-auto pb-16">
          <div className="grid grid-cols-2 md-lg:grid-cols-1 gap-8">
            {/*lado carrusel*/}
            <div className="flex flex-col">
              <div className="w-full">
                <div className="product-detail-zoom-frame">
                  <InnerImageZoom
                    className="product-detail-zoom"
                    src={smallImage}
                    zoomSrc={largeImage}
                    zoomScale={1.2}
                    zoomPreload={false}
                    hasSpacer={false}
                    moveType="pan"
                    zoomType="hover"
                    imgAttributes={{
                      alt: product?.name || "Producto",
                      loading: "eager",
                    }}
                  />
                </div>
              </div>
              <div className="pt-0 pb-2 sm:py-3">
                {getImagesToDisplay().length > 1 && (
                  <div className="flex gap-1 overflow-x-auto scrollbar-hide">
                    {getImagesToDisplay().map((img, i) => (
                      <button
                        key={i}
                        onClick={() => setSelectedImage(img)}
                        aria-label={`Ver imagen ${i + 1}`}
                        className={`flex-shrink-0 w-[19%] border-2 rounded overflow-hidden transition-all ${
                          selectedImage === img
                            ? "border-[#ae1d22]"
                            : "border-gray-200 hover:border-gray-400"
                        }`}
                      >
                        <img
                          src={img}
                          alt={`Miniatura ${i + 1}`}
                          className="w-full h-16 sm:h-14 xs:h-12 object-contain"
                        />
                      </button>
                    ))}
                  </div>
                )}
              </div>
            </div>
            {/*End lado carrusel*/}
            {/*Tarjeta de producto*/}
            <div className="flex flex-col m-0">
              <div className="text-xs font-bold mb-[0.5625rem]">
                <p className=" text-gray-800 ">{product.brand}</p>
              </div>
              <div className="text-2xl leading-6  text-slate-700 font-bold mb-[0.5rem] pr-7 relative">
                <p className="text-base leading-6  text-gray-600 mt-1">
                  {product.name}{" "}
                </p>
                <div className="h-5 absolute right-0 top-0 w-5">
                  <button
                    onClick={add_wishlist}
                    aria-label="Agregar a lista de deseos"
                    className="p-2 text-red-500 hover:text-red-600 transition-colors"
                  >
                    <FaHeart size={20} />
                  </button>
                </div>
              </div>
              <div className="text-slate-600">
                <p>{product.description} </p>
                <p className="text-slate-600 py-1 font-semibold">
                  Vendido por: {product.shopName}
                </p>
              </div>

              {/* Price Display CORREGIDO */}
              <div className="flex items-center gap-3">
                {hasActiveDiscount ? (
                  <>
                    <span className="text-sm leading-6 text-gray-500 line-through">
                      S/{calculatedPrice.toFixed(2)}
                    </span>
                    <span className="text-2xl leading-6 text-red-500">
                      S/{calculatedDiscount.toFixed(2)}
                    </span>
                    <span className="bg-[rgba(230,0,0,0.2)] text-[#e60000] text-xs font-extrabold tracking-[0.075rem] ml-1 py-1.5 px-1.5 rounded-[0.125rem] text-ellipsis">
                      {discountPercentage}%
                    </span>
                  </>
                ) : (
                  <p className="text-2xl leading-6 text-black">
                    S/{calculatedPrice.toFixed(2)}
                  </p>
                )}
              </div>

              {/* Variant Selection */}
              {product.hasVariants && selectedVariant && (
                <div className="space-y-4">
                  <div>
                    <p className="py-1">COLOR: {selectedVariant.color}</p>
                    <div className="flex flex-wrap gap-2 hidden">
                      {product.variants.map((variant) => (
                        <button
                          key={variant._id}
                          type="button"
                          onClick={() => {
                            setSelectedVariant(variant);
                            setSelectedSize(variant.sizes[0]?.size || null);
                          }}
                          className={`px-4 py-2 border rounded-md text-sm font-medium ${
                            selectedVariant._id === variant._id
                              ? "border-red-500 bg-red-50 text-red-700"
                              : "border-gray-300 hover:bg-gray-50"
                          }`}
                        >
                          {variant.color}
                        </button>
                      ))}
                    </div>
                  </div>
                  <div>
                    <div className="flex flex-wrap gap-2">
                      {sortSizes(selectedVariant.sizes).map((sizeObj) => {
                        const isOutOfStock = sizeObj.stock <= 0;
                        return (
                          <button
                            key={sizeObj._id}
                            type="button"
                            onClick={() =>
                              !isOutOfStock && setSelectedSize(sizeObj.size)
                            }
                            disabled={isOutOfStock}
                            className={`relative w-10 h-10 flex items-center justify-center rounded-md border text-sm font-medium ${
                              selectedSize === sizeObj.size
                                ? "border-red-500 bg-red-50 text-red-700"
                                : isOutOfStock
                                ? "border-gray-200 bg-gray-100 text-gray-400 cursor-not-allowed"
                                : "border-gray-300 hover:bg-gray-50"
                            }`}
                            aria-label={`Talla ${sizeObj.size}${
                              isOutOfStock ? " - Agotado" : ""
                            }`}
                          >
                            {sizeObj.size}
                            {isOutOfStock && (
                              <div className="absolute inset-0 flex items-center justify-center">
                                <div className="w-full h-px bg-red-500 transform rotate-45"></div>
                              </div>
                            )}
                          </button>
                        );
                      })}
                    </div>
                    {!selectedSize && (
                      <p className="text-xs text-red-500 mt-1">
                        Por favor selecciona una talla
                      </p>
                    )}
                  </div>
                </div>
              )}

              {/* Quantity and Add to Cart */}
              <div className="flex flex-wrap gap-4 pt-4 border-t">
                {currentStock > 0 ? (
                  <>
                    <div className="flex items-center bg-slate-200 rounded-md overflow-hidden">
                      <button
                        onClick={dec}
                        className="px-4 py-2 text-xl hover:bg-slate-300 transition-colors"
                        aria-label="Reducir cantidad"
                      >
                        -
                      </button>
                      <div className="px-4 py-2 text-xl">{quantity}</div>
                      <button
                        onClick={inc}
                        className="px-4 py-2 text-xl hover:bg-slate-300 transition-colors"
                        aria-label="Aumentar cantidad"
                      >
                        +
                      </button>
                    </div>
                    <div>
                      <button
                        onClick={add_card}
                        className="px-6 py-3 bg-red-500 text-white rounded-md hover:bg-red-600 transition-colors"
                      >
                        Agregar al Carrito
                      </button>
                    </div>
                  </>
                ) : (
                  ""
                )}
              </div>

              {/* Stock Info */}
              <div className="flex items-center gap-4 py-4 border-t">
                <span className="font-semibold">Disponibilidad:</span>
                <span
                  className={`font-medium ${
                    currentStock > 0 ? "text-green-600" : "text-red-500"
                  }`}
                >
                  {currentStock > 0 ? `En stock (${currentStock})` : "Agotado"}
                </span>
              </div>

              {/* Botón para guía de tallas */}
              {product.brand && (
                <div className="py-3 border-t">
                  <button
                    onClick={openSizeGuide}
                    disabled={brandLoading}
                    className="flex items-center gap-2 text-blue-600 hover:text-blue-800 transition-colors disabled:opacity-50 disabled:cursor-not-allowed"
                  >
                    {brandLoading ? (
                      <>
                        <div className="w-4 h-4 border-2 border-blue-600 border-t-transparent rounded-full animate-spin"></div>
                        <span className="text-sm font-medium">
                          Cargando guía...
                        </span>
                      </>
                    ) : (
                      <>
                        <FaRuler className="text-lg" />
                        <span className="text-sm font-medium">
                          Ver guía de tallas de {product.brand}
                        </span>
                      </>
                    )}
                  </button>
                </div>
              )}

              <div className="flex py-5 gap-5">
                <div className="w-[150px] text-black font-bold text-xl flex flex-col gap-5">
                  <span>Compartir en</span>
                </div>

                <div className="flex flex-col gap-5">
                  <ul className="flex justify-start items-center gap-3">
                    <li>
                      <a
                        className="w-[38px] h-[38px] hover:bg-[#FF3A59] hover:text-white flex justify-center items-center bg-indigo-500 rounded-full text-white"
                        href="https://www.facebook.com/share/1FkgDAhPGx/?mibextid=wwXIfr"
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        {" "}
                        <FaFacebookF />{" "}
                      </a>
                    </li>
                    <li>
                      <a
                        className=" w-[38px] h-[38px] hover:bg-[#FF3A59]   hover:text-white  flex justify-center items-center rounded-full text-white   bg-gradient-to-tr from-[#833AB4] via-[#C13584] to-[#E1306C]   hover:opacity-90 transition-all"
                        href="https://www.instagram.com/tekos.peru?igsh=MXg0bzZ6ZHAwY2l1aQ%3D%3D&utm_source=qr"
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        {" "}
                        <FaInstagram />{" "}
                      </a>
                    </li>
                    <li>
                      <a
                        className="w-[38px] h-[38px]  hover:bg-[#FF3A59] hover:text-white flex justify-center items-center rounded-full text-white hover:opacity-90 transition-all  bg-gradient-to-tr from-[#25F4EE] to-[#FE2C55]"
                        href="https://www.tiktok.com/@tekos.peru?_t=ZM-8wlJsEKl0vm&_r=1"
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        {" "}
                        <FaTiktok />{" "}
                      </a>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
            {/*End Tarjeta de producto*/}
          </div>
        </div>
      </section>
      {/* ... (resto del componente se mantiene igual) ... */}
      <section>
        <div className="w-[85%] md:w-[80%] sm:w-[90%] lg:w-[90%] h-full mx-auto pb-16">
          <div className="flex flex-wrap">
            <div className="w-full md-lg:w-full">
              <div className="pr-4 md-lg:pr-0">
                <h2 className="text-2xl py-8 text-slate-600">
                  Productos Relacionados{" "}
                </h2>
                <div>
                  <Swiper
                    slidesPerView="auto"
                    breakpoints={{
                      1280: { slidesPerView: 4 },
                      565: { slidesPerView: 2 },
                      0: { slidesPerView: 1 },
                    }}
                    spaceBetween={25}
                    loop={canLoopRelated}
                    pagination={{
                      clickable: true,
                      el: ".custom_bullet",
                    }}
                    modules={[Pagination]}
                    className="mySwiper"
                  >
                    {relatedProducts.map((p, i) => {
                      const {
                        hasDiscount,
                        displayPrice,
                        originalPrice,
                        discountPercent,
                      } = getProductPriceInfo(p);

                      return (
                        <SwiperSlide key={i}>
                          <Link
                            to={`/product/details/${p.slug}`}
                            className="block group"
                          >
                            <div className="relative h-[270px] overflow-hidden">
                              <div className="w-full h-full">
                                <img
                                  className="w-full h-full object-contain md:object-cover group-hover:scale-105 transition-transform duration-300"
                                  src={getMainImage(p)}
                                  alt={p.name}
                                />
                                <div className="absolute h-full w-full top-0 left-0 bg-[#000] opacity-10 group-hover:opacity-30 transition-all duration-500"></div>
                              </div>

                              {/* Badge de descuento */}
                              {hasDiscount && (
                                <div className="flex justify-center items-center absolute text-white w-[38px] h-[38px] rounded-full bg-red-500 font-semibold text-xs left-2 top-2">
                                  -{discountPercent}%
                                </div>
                              )}
                            </div>
                            <div className="p-4 flex flex-col gap-1">
                              <h2 className="text-slate-600 text-sm font-bold line-clamp-2 min-h-[40px]">
                                {p.name}
                              </h2>

                              {/* Precios */}
                              <div className="flex justify-start items-center gap-3 flex-wrap">
                                {hasDiscount ? (
                                  <div className="flex items-center gap-2">
                                    <h2 className="text-lg font-bold text-red-600">
                                      S/{displayPrice?.toFixed(2)}
                                    </h2>
                                    <span className="text-sm text-gray-500 line-through">
                                      S/{originalPrice?.toFixed(2)}
                                    </span>
                                  </div>
                                ) : (
                                  <h2 className="text-lg font-bold text-slate-700">
                                    S/{displayPrice?.toFixed(2)}
                                  </h2>
                                )}
                                <div className="flex">
                                  <Rating ratings={p.rating} />
                                </div>
                              </div>

                              {/* Etiqueta "OFERTA" */}
                              {hasDiscount && (
                                <span className="inline-block mt-1 px-2 py-1 bg-red-100 text-red-600 text-xs font-medium rounded max-w-[80px]">
                                  OFERTA
                                </span>
                              )}
                            </div>
                          </Link>
                        </SwiperSlide>
                      );
                    })}
                  </Swiper>
                </div>
                <div className="w-full flex justify-center items-center py-8">
                  <div className="custom_bullet justify-center gap-3 !w-auto"></div>
                </div>
              </div>
            </div>

            <div className="w-full">
              <div className="pl-4 md:pl-0">
                <div className=" py-2">
                  <h2 className="font-bold">De {product.shopName}</h2>
                </div>

                <div className="mt-3 border p-3">
                  <Swiper
                    slidesPerView="auto"
                    breakpoints={{
                      1280: { slidesPerView: 4 },
                      565: { slidesPerView: 2 },
                      0: { slidesPerView: 1 },
                    }}
                    spaceBetween={25}
                    loop={canLoopMore}
                    pagination={{
                      clickable: true,
                      el: ".custom_bullet",
                    }}
                    modules={[Pagination]}
                    className="mySwiper"
                  >
                    {moreProducts.map((p, i) => {
                      const {
                        hasDiscount,
                        displayPrice,
                        originalPrice,
                        discountPercent,
                      } = getProductPriceInfo(p);

                      return (
                        <SwiperSlide key={i}>
                          <Link
                            to={`/product/details/${p.slug}`}
                            className="block group"
                          >
                            <div className="relative h-[270px] overflow-hidden">
                              <div className="w-full h-full">
                                <img
                                  className="w-full h-full object-contain md:object-cover group-hover:scale-105 transition-transform duration-300"
                                  src={getMainImage(p)}
                                  alt={p.name}
                                />
                                <div className="absolute h-full w-full top-0 left-0 bg-[#000] opacity-10 group-hover:opacity-30 transition-all duration-500"></div>
                              </div>

                              {/* Badge de descuento */}
                              {hasDiscount && (
                                <div className="flex justify-center items-center absolute text-white w-[38px] h-[38px] rounded-full bg-red-500 font-semibold text-xs left-2 top-2">
                                  -{discountPercent}%
                                </div>
                              )}
                            </div>
                            <div className="p-4 flex flex-col gap-1">
                              <h2 className="text-slate-600 text-sm font-bold line-clamp-2 min-h-[40px]">
                                {p.name}
                              </h2>

                              {/* Precios */}
                              <div className="flex justify-start items-center gap-3 flex-wrap">
                                {hasDiscount ? (
                                  <div className="flex items-center gap-2">
                                    <h2 className="text-lg font-bold text-red-600">
                                      S/{displayPrice?.toFixed(2)}
                                    </h2>
                                    <span className="text-sm text-gray-500 line-through">
                                      S/{originalPrice?.toFixed(2)}
                                    </span>
                                  </div>
                                ) : (
                                  <h2 className="text-lg font-bold text-slate-700">
                                    S/{displayPrice?.toFixed(2)}
                                  </h2>
                                )}
                                <div className="flex">
                                  <Rating ratings={p.rating} />
                                </div>
                              </div>

                              {/* Etiqueta "OFERTA" */}
                              {hasDiscount && (
                                <span className="inline-block mt-1 px-2 py-1 bg-red-100 text-red-600 text-xs font-medium rounded max-w-[80px]">
                                  OFERTA
                                </span>
                              )}
                            </div>
                          </Link>
                        </SwiperSlide>
                      );
                    })}
                  </Swiper>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      <section>
        <div className="w-[85%] md:w-[80%] sm:w-[90%] lg:w-[90%] h-full mx-auto">
          {/*retirar el swuiper mas arriba*/}
          <div className="w-full flex justify-center items-center py-8">
            <div className="custom_bullet justify-center gap-3 !w-auto"></div>
          </div>
        </div>
        {sizeGuideModal && brandDetails && (
          <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4">
            <div className="bg-white rounded-lg max-w-4xl w-full max-h-[90vh] overflow-y-auto">
              {/* Header */}
              <div className="flex justify-between items-center p-6 border-b sticky top-0 bg-white z-10">
                <div>
                  <h2 className="text-xl font-semibold text-gray-800">
                    Guía de Tallas - {brandDetails.name}
                  </h2>
                  <p className="text-sm text-gray-600 mt-1">
                    Consulta la talla correcta para tu producto
                  </p>
                </div>
                <button
                  onClick={closeSizeGuide}
                  className="text-gray-500 hover:text-gray-700 transition-colors p-2"
                  aria-label="Cerrar"
                >
                  <FaTimes size={24} />
                </button>
              </div>
              {/* Content */}
              <div className="p-6">
                {brandDetails.sizeGuide ? (
                  <div className="space-y-6">
                    {/* Imagen de la guía de tallas */}
                    <div className="flex justify-center">
                      <img
                        src={brandDetails.sizeGuide}
                        alt={`Guía de tallas ${brandDetails.name}`}
                        className="max-w-full h-auto rounded-lg shadow-md border"
                      />
                    </div>
                    {/* Información adicional */}
                    <div className="bg-blue-50 p-4 rounded-lg">
                      <h3 className="font-semibold text-blue-800 mb-3 flex items-center gap-2">
                        <FaRuler />
                        Consejos para medir correctamente
                      </h3>
                      <ul className="text-sm text-blue-700 space-y-2">
                        <li>
                          • <strong>Largo del pie:</strong> Mide desde el talón
                          hasta la punta del dedo más largo
                        </li>
                        <li>
                          • <strong>Ancho del pie:</strong> Mide alrededor de la
                          parte más ancha del pie (metatarso)
                        </li>
                        <li>
                          • <strong>Altura del empeine:</strong> Mide la altura
                          desde la planta hasta el empeine
                        </li>

                        <li>
                          • Si estás entre dos tallas, te recomendamos elegir la
                          talla más grande
                        </li>
                      </ul>
                    </div>
                  </div>
                ) : (
                  <div className="text-center py-8">
                    <FaRuler className="text-4xl text-gray-400 mx-auto mb-4" />
                    <h3 className="text-lg font-semibold text-gray-600 mb-2">
                      Guía de tallas no disponible
                    </h3>
                    <p className="text-gray-500">
                      {brandDetails.name} no tiene una guía de tallas disponible
                      en este momento.
                    </p>
                  </div>
                )}
              </div>

              {/* Footer */}
              <div className="p-6 border-t bg-gray-50">
                <div className="flex flex-col sm:flex-row justify-between items-center gap-4">
                  <div className="text-sm text-gray-600">
                    ¿Necesitas ayuda con las tallas? Contacta a nuestro servicio
                    al cliente
                  </div>
                  <div className="flex gap-3">
                    <button
                      onClick={closeSizeGuide}
                      className="px-6 py-2 border border-gray-300 text-gray-700 rounded hover:bg-gray-100 transition-colors"
                    >
                      Cerrar
                    </button>

                    {brandDetails.sizeGuide && (
                      <a
                        href={brandDetails.sizeGuide}
                        download={`guia-tallas-${brandDetails.name}.jpg`}
                        className="px-6 py-2 bg-blue-600 text-white rounded hover:bg-blue-700 transition-colors flex items-center gap-2"
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        <FaDownload size={16} />
                        Descargar Guía
                      </a>
                    )}
                  </div>
                </div>
              </div>
            </div>
          </div>
        )}
      </section>
      <Footer />
    </div>
  );
};
export default Details;
